import { useRouter } from 'next/router';

import Loader from '@components/common/loader';
import useTypedSelector from '@hooks/use-typed-selector';

const AuthRoute: React.FC = (props) => {
  const { children } = props;
  const router = useRouter();

  const { token } = useTypedSelector((state) => state.auth);

  if (token) {
    router.replace('/documents');

    return <Loader size="md" positionFixedCenter />;
  }

  return <>{children}</>;
};

export default AuthRoute;
